var map = {
	"./attachment.svg": 8756,
	"./cancel_icon.svg": 8376,
	"./clock-white.svg": 2363,
	"./clock.svg": 2075,
	"./delete.svg": 930,
	"./edit.svg": 975,
	"./employment.svg": 541,
	"./export.svg": 3205,
	"./icon_editar.svg": 6638,
	"./info.svg": 9328,
	"./lock.svg": 5482,
	"./medical_exam.svg": 8118,
	"./medical_meet.svg": 7370,
	"./medical_meet_2.svg": 2049,
	"./notify.svg": 2920,
	"./pdf_download.svg": 7006,
	"./search.svg": 4343,
	"./send_message.svg": 1121,
	"./symptom_0.svg": 4649,
	"./symptom_1.svg": 9256,
	"./symptom_2.svg": 3643,
	"./symptom_3.svg": 3274,
	"./symptom_4.svg": 6485,
	"./task_due_date.svg": 2494,
	"./transfer-professional.svg": 7270,
	"./transfer.svg": 7422,
	"./video_call.svg": 7515,
	"./weekly_report_level_pain_1.svg": 5751,
	"./weekly_report_level_pain_2.svg": 1300,
	"./weekly_report_level_pain_3.svg": 8549,
	"./your_photo.svg": 4559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;